import { c as _c } from "react/compiler-runtime";
import { useButton } from "@website/ui/button/button.hook";
import styles from "@website/ui/button/button.module.scss";
import { ButtonPropertiesType } from "@website/ui/button/button.types";
import { Loading } from "@website/ui/loading";
import omit from "lodash-es/omit";
import Link from "next/link";
import { FC } from "react";
export const Button: FC<ButtonPropertiesType> = properties => {
  const $ = _c(29);
  const {
    children,
    className,
    color: t0,
    disabled,
    EndIcon,
    fullWidth,
    loading,
    loadingWithText,
    role,
    size: t1,
    StartIcon,
    variant: t2,
    text,
    iconColorMode: t3,
    replace,
    equalDimension,
    divButtonType,
    loadingColor: t4
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const size = t1 === undefined ? "medium" : t1;
  const variant = t2 === undefined ? "contained" : t2;
  const iconColorMode = t3 === undefined ? "custom" : t3;
  const loadingColor = t4 === undefined ? "white" : t4;
  const {
    buttonProps,
    linkProps,
    divButtonProps
  } = useButton(properties);
  const classNames = `${styles.button} ${styles[variant]} ${styles[color]} ${disabled ? styles.disabled : ""} ${styles[size]} ${fullWidth ? styles["full-width"] : ""} ${equalDimension ? styles["equal-dimension"] : ""} ${className ?? ""}`;
  let t5;
  if ($[0] !== EndIcon || $[1] !== StartIcon || $[2] !== children || $[3] !== iconColorMode || $[4] !== loading || $[5] !== loadingColor || $[6] !== loadingWithText || $[7] !== size || $[8] !== text) {
    t5 = loading ? children && loadingWithText ? <Loading color="primary" size="xs"><span className="mx-1">{children}</span></Loading> : <Loading color={loadingColor} /> : <>{StartIcon ? <span className={`${styles.icon} ${iconColorMode === "inherit" ? styles["icon-inherit"] : ""} ${size === "x-small" ? styles["icon-large"] : children ? styles["icon-small"] : styles["icon-medium"]}`}>{StartIcon}</span> : null}{text ? <div className={styles.text}>{text}</div> : null}{children ? <span className="mx-1">{children}</span> : null}{EndIcon ? <span className={`${styles.icon} ${iconColorMode === "inherit" ? styles["icon-inherit"] : ""} ${size === "x-small" ? styles["icon-large"] : children ? styles["icon-small"] : styles["icon-medium"]}`}>{EndIcon}</span> : null}</>;
    $[0] = EndIcon;
    $[1] = StartIcon;
    $[2] = children;
    $[3] = iconColorMode;
    $[4] = loading;
    $[5] = loadingColor;
    $[6] = loadingWithText;
    $[7] = size;
    $[8] = text;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const elements = t5;
  if (role === "link") {
    let t6;
    if ($[10] !== linkProps) {
      t6 = omit(linkProps, "prefetch");
      $[10] = linkProps;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== classNames || $[13] !== elements || $[14] !== t6) {
      t7 = <a {...t6} className={classNames}>{elements}</a>;
      $[12] = classNames;
      $[13] = elements;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  if (role === "next-link") {
    const t6 = replace ?? false;
    let t7;
    if ($[16] !== classNames || $[17] !== elements || $[18] !== linkProps || $[19] !== t6) {
      t7 = <Link {...linkProps} className={classNames} replace={t6}>{elements}</Link>;
      $[16] = classNames;
      $[17] = elements;
      $[18] = linkProps;
      $[19] = t6;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    return t7;
  }
  if (divButtonType) {
    let t6;
    if ($[21] !== classNames || $[22] !== divButtonProps || $[23] !== elements) {
      t6 = <div {...divButtonProps} className={classNames}>{elements}</div>;
      $[21] = classNames;
      $[22] = divButtonProps;
      $[23] = elements;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    return t6;
  }
  let t6;
  if ($[25] !== buttonProps || $[26] !== classNames || $[27] !== elements) {
    t6 = <button {...buttonProps} className={classNames}>{elements}</button>;
    $[25] = buttonProps;
    $[26] = classNames;
    $[27] = elements;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  return t6;
};